export default __webpack_public_path__ + "static/media/sports.12fecde6.webp";